import {
  REDIRECT_DONE, REDIRECT_INIT, UPDATE_BLOCK_ROUTING, NOTIFY_USER_ROUTE_BLOCKED, USER_CONFIRMS_TO_CHANGE_ROUTE,
} from './types/redirectActionTypes';

export const getRedirectInit = (url) => ({
  type: REDIRECT_INIT,
  payload: url,
});

export const getRedirectDone = () => ({
  type: REDIRECT_DONE,
});

export function blockRoutingAction(data) {
  return {
    type: UPDATE_BLOCK_ROUTING,
    payload: data,
  };
}

export function triggerConfirmationDialogAction(data) {
  return {
    type: NOTIFY_USER_ROUTE_BLOCKED,
    payload: data,
  };
}

export function triggerRedirect(data) {
  return {
    type: USER_CONFIRMS_TO_CHANGE_ROUTE,
    payload: data,
  };
}
